// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tcl_hvTpyU8oKRSK{display:flex;flex-wrap:wrap;gap:8px;width:100%;list-style-type:none}.tcl_hvTpyU8oKRSK .g2jym_DXEcqkvAJf{outline:var(--py-primary-5) auto 1px}.tcl_hvTpyU8oKRSK:focus{outline:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tagList": `tcl_hvTpyU8oKRSK`,
	"focusedItem": `g2jym_DXEcqkvAJf`
};
export default ___CSS_LOADER_EXPORT___;
